/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, FC } from 'react'
import { FormControl, Button } from '@material-ui/core'
import { PersonOutlineOutlined, ThumbDownAltOutlined } from '@material-ui/icons'
import { FlatfileButton } from '@flatfile/react'
import API from '@aws-amplify/api'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { SignupContext } from '../../../context/SignupContextContainer'
import flatFileButtonSettings from '../flatFileButtonSettings'
import SIGNUP_STEPS from '../../../utils/constants'

const ProspectManagementForm: FC = () => {
  const history = useHistory()
  const { setSignupStep } = useContext(SignupContext)

  const isWeekday = (date): boolean => {
    const day = date.getDay()
    return day !== 0 && day !== 6
  }

  const tomorrow = moment()
    .add(1, 'day')
    .toDate()

  let tomorrowOrNextWeekday = moment(tomorrow)
  if (tomorrowOrNextWeekday.day() === 0) {
    // Custom send date is Sunday, add one day to make it Monday
    tomorrowOrNextWeekday = tomorrowOrNextWeekday.add(1, 'day')
  } else if (tomorrowOrNextWeekday.day() === 6) {
    // Custom send date is Saturday, add two days to make it Monday
    tomorrowOrNextWeekday = tomorrowOrNextWeekday.add(2, 'days')
  }

  const onData = async (localResults): Promise<void> => {
    // do something with the results
    // eslint-disable-next-line dot-notation
    const result = localResults['$data'].filter(record => record.valid)
    const myInit = { body: result }
    await API.post('mav-outlook-api', '/leads/import', myInit)
  }
  const onRecordChange = (record): any => {
    let response
    if (record.email && record.email.toString().toLowerCase() !== record.email) {
      response.email = {
        value: record.email?.toLocaleString().toLocaleLowerCase(),
        info: [{ message: 'converted to lowercase', level: 'info' }],
      }
    }
    if (
      (record.sendDate && !moment(record.sendDate.toString(), 'MM/DD/YYYY', true).isValid()) ||
      moment(record.sendDate?.toString()).isBefore(new Date(), 'day') ||
      (record.sendDate && !isWeekday(new Date(record.sendDate.toLocaleString())))
    ) {
      response.sendDate = {
        value: moment(tomorrowOrNextWeekday).format('MM/DD/YYYY'),
        info: [{ message: 'Send date must be in the future and a weekday', level: 'info' }],
      }
    }
    if (record.status !== 'emailScheduled') {
      response.maneuver = {
        value: null,
      }
      response.sendDate = {
        value: null,
      }
      response.mission = {
        value: null,
      }
    }
    return response
  }

  const onRecordInit = (record): any => {
    let response
    if (record.email && record.email.toString().toLowerCase() !== record.email) {
      response.email = {
        value: record.email?.toLocaleString().toLocaleLowerCase(),
        info: [{ message: 'converted to lowercase', level: 'info' }],
      }
    }
    if (
      (record.sendDate && !moment(record.sendDate.toString(), 'MM/DD/YYYY', true).isValid()) ||
      moment(record.sendDate?.toString()).isBefore(new Date(), 'day') ||
      (record.sendDate && !isWeekday(new Date(record.sendDate.toLocaleString())))
    ) {
      response.sendDate = {
        value: moment(tomorrowOrNextWeekday).format('MM/DD/YYYY'),
        info: [{ message: 'Send date must be in the future and a weekday', level: 'info' }],
      }
    }
    if (record.status !== 'emailScheduled') {
      response.maneuver = {
        value: null,
      }
      response.sendDate = {
        value: null,
      }
      response.mission = {
        value: null,
      }
    }
    return response
  }

  const skipStep = (): void => {
    setSignupStep(SIGNUP_STEPS.WRITER)
    history.push('/client/writer')
  }

  return (
    <div className="signup-form">
      <p className="sub-title no-border">
        Start Your
        <br />
        Prospect Management
      </p>
      <p className="description">
        Upload lists of your current prospects you do and DO NOT want MaverickApp to engage with. We
        know things change, so you can easily edit prospect information later as well.
      </p>
      <div className="form">
        <FormControl>
          <FlatfileButton
            className="inputButton"
            licenseKey="b36ed275-3feb-46cf-bc34-c6154624a027"
            customer={{ userId: '12345' }}
            settings={flatFileButtonSettings}
            onData={onData}
            onRecordChange={onRecordChange}
            onRecordInit={onRecordInit}
          >
            <ThumbDownAltOutlined />
            DO NOT CONTACT LIST (.CSV ONLY)
          </FlatfileButton>
        </FormControl>
        <FormControl>
          <FlatfileButton
            className="inputButton"
            licenseKey="b36ed275-3feb-46cf-bc34-c6154624a027"
            customer={{ userId: '12345' }}
            settings={flatFileButtonSettings}
            onData={onData}
            onRecordChange={onRecordChange}
            onRecordInit={onRecordInit}
          >
            <PersonOutlineOutlined />
            CURRENT PROSPECTS LIST (.CSV ONLY)
          </FlatfileButton>
        </FormControl>
        <Button size="medium" color="primary" className="skipThis" onClick={skipStep}>
          Skip this step.
        </Button>
      </div>
    </div>
  )
}
export default ProspectManagementForm
